import { createStyles } from "@mantine/emotion";

export default createStyles ( ( theme, props ) => ( {
	postContainer: {
		padding       : props?.deviceViewTab ? "0 20px" : " 0 200px",
		background    : theme.other.darkMode ? theme.other.paletteNew.darkModeInclinedBlack2 : theme.other.paletteNew.secondaryBackgroundGrey,
		display       : "flex",
		flexDirection : "column",
		margin        : "5rem 0"
	},
	midSectionContainer: {
		width          : "100%",
		display        : "flex",
		justifyContent : "space-between",
		paddingBottom  : "2rem",
		flexWrap       : "wrap"
	},
	middleLeftSection: {
		display    : "flex",
		alignItems : "center"
	},
	middleRightSection: {
		display    : "flex",
		alignItems : "center"
	},
	postImageConatiner: {
		padding: "3rem 0 1rem 0"
	},
	postImage: {
		borderRadius: "20px"
	},
	postContentConatiner: {
		width         : "100%",
		display       : "flex",
		flexDirection : props?.deviceViewTab ? "column" : "row",
		gap           : "3rem",
		padding       : "2rem 0 3rem"
	},
	contentParagraph: {
		color    : theme.other.colors.text.primary,
		fontSize : "1.5rem",
		width    : props?.deviceViewTab ? "100%" : "60%"
	},
	contentTagsContainer: {
		display       : "flex",
		flexDirection : "column",
		width         : props?.deviceViewTab ? "100%" : "40%",
		gap           : "2rem"
	},
	postHeading: {
		fontSize        : "3.5rem",
		fontWeight      : "500",
		wordBreak       : "break-word",
		textOverflow    : "ellipsis",
		WebkitLineClamp : 3,
		overflow        : "hidden",
		display         : "-webkit-box",
		WebkitBoxOrient : "vertical",
		marginBottom    : "1rem"
	},
	postDescription: {
		fontSize : "1.5rem",
		color    : theme.other.darkMode ? theme.other.paletteNew.darkModeWhite80 : theme.other.paletteNew.secondaryDarkGrey
	},
	shareComponentContainer: {
		display    : "flex",
		alignItems : "center",
		padding    : "0 1rem"
	},
	shareTitle: {
		fontWeight  : "500",
		marginRight : "1rem"
	},
	seperator: {
		borderRadius : "50%",
		height       : "3px",
		width        : "3px",
		background   : theme.other.darkMode ? theme.other.paletteNew.darkModeWhite80 : theme.other.paletteNew.secondaryDarkGrey,
		margin       : "0 1rem"

	}
} ) );
